import { useLocation } from 'react-router-dom';
import Header from '../public/Header';
import Footer from '../public/Footer';
import PageMeta from '../ui/PageMeta';

interface PublicLayoutProps {
  children: React.ReactNode;
}

export default function PublicLayout({ children }: PublicLayoutProps) {
  const { pathname } = useLocation();
  const isCmsPage = /^\/page\/[^/]+$/.test(pathname) || /^\/(ar|zh|ko)\/page\/[^/]+$/.test(pathname);

  return (
    <div className="flex h-[100dvh] max-h-[100dvh] min-h-0 w-full max-w-full flex-col overflow-x-hidden bg-gray-950">
      {!isCmsPage && <PageMeta />}
      <div className="relative z-[100] shrink-0 overflow-visible">
        <Header />
      </div>
      <main className="relative z-0 min-h-0 flex-1 overflow-x-hidden overflow-y-auto overscroll-y-contain">
        {children}
        <Footer />
      </main>
    </div>
  );
}
